<template>
  <Feed
    :states="{
      empty: {
        title: t('notifications.list.emptyTitle'),
        description: t('notifications.list.emptyDescription')
      }
    }"
    :store="{
      read: fetchNotifications
    }"
    :options="{
      limit: 20
    }"
    :skeleton="{
      structure: [
        { block: 'text', size: 'small' },
        { block: 'text', size: 'large' }
      ]
    }"
    v-slot="{ items }"
    class="gap-thin cols-1"
  >
    <NotificationItem
      v-for="notification in items"
      :key="notification._id"
      :notification="notification"
      @click="handleNotificationClick(notification)"
    />
  </Feed>
</template>

<script setup>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import Feed from '@martyrs/src/design-system/components/Feed/Feed.vue';
import NotificationItem from '../blocks/NotificationItem.vue';
import * as auth from '@martyrs/src/modules/auth/views/store/auth.js';
import { actions } from '@martyrs/src/modules/notifications/store/notifications.store.js';

const { t } = useI18n();
const { handleNotificationAction } = inject('useNotifications')();

const fetchNotifications = async (options) => {
  const userId = auth.state.user._id;
  if (!userId) return [];

  const data = await actions.getNotifications(userId);
  return data || [];
};

const handleNotificationClick = (notification) => {
  if (notification._id) {
    handleNotificationAction({
      notificationId: notification._id,
      ...notification.metadata
    });
  }
};
</script>
